import {  TERRITORY_LOOKUP } from "../../lookup/Consts";
import { getAgencyLookupValues, getLookupValues } from "../../lookup/services/LookupHelpers";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { isNullOrUndefined } from "../../util/tools";
import { DATE_INPUT, DROPDOWN_INPUT, READ_ONLY_INPUT, TEXT_INPUT } from "../Consts";
import { ISocIP } from "../types/ISocIP";
import { ITerritories } from "../types/ITerritories";
import { IRepresentationPool } from "../types/IRepresentationPool";
import { IRepresentationPoolCategory } from "../types/IRepresentationPoolCategory";
import { IUsagePool } from "../types/usageTypes/IUsagePool";

export class InterestedPartyDetailsMapper {
    public static mapIPRepresentationTerritory(territories: ITerritories[], lookups?: any, includeTerritory?: string, excludeTerritory?: string, repID?: number): any {
        let territory;
        let includeTransformed;
        let excludeTransformed;
        let mergedArray;
        if (includeTerritory || excludeTerritory) {
            if (includeTerritory) {
                let includeTerritories = includeTerritory.split(',');
                includeTransformed = includeTerritories.map(value => ({
                    includeExclude: 'I',
                    value: value.toUpperCase()
                }));
            }
            if (excludeTerritory) {
                let excludeTerritories = excludeTerritory.split(',');
                excludeTransformed = excludeTerritories.map(value => ({
                    includeExclude: 'E',
                    value: value.toUpperCase()
                }));
            }

            if (includeTerritory && excludeTerritory) {
                mergedArray = includeTransformed.concat(excludeTransformed);
            }
            else if (includeTerritory.length > 0 && excludeTerritory.length === 0) {
                mergedArray = includeTransformed;
            }
            else if (excludeTerritory.length > 0 && includeTerritory.length === 0) {
                mergedArray = excludeTransformed;
            }
            let representationIDNo = territories ? territories[0].representationID : repID;
            let territoryDetails
            return mergedArray.map(lineItem => {
                if (territories) {
                    territoryDetails = territories.filter(x => (x.code === lineItem.value && x.includeExclude === lineItem.includeExclude))
                }
                const isTerritoryPresent = territoryDetails && territoryDetails.length;
                if (lookups) {
                    territory = lookups.filter(x => x.code === ((lineItem.value) as any))
                    if (territory) {
                        return {
                            code: territory.length > 0 ? territory[0].code : '',
                            description: territory.length > 0 ? territory[0].description : lineItem.value,
                            includeExclude: lineItem.includeExclude,
                            isDeleted: isTerritoryPresent ? territoryDetails[0].isDeleted : false,
                            lastModifiedDate: isTerritoryPresent ? territoryDetails[0].lastModifiedDate : new Date(),
                            representationID: isTerritoryPresent ? territoryDetails[0].representationID : representationIDNo,
                            representationTerritoryID: isTerritoryPresent ? territoryDetails[0].representationTerritoryID : 0,
                            territoryID: territory.length > 0 ? territory[0].typeID : 0,
                            tisnValidFrom: isTerritoryPresent ? territoryDetails[0].tisnValidFrom : new Date()
                        }
                    }

                }

            })


        }
        else if (territories && includeTerritory === ' ' && excludeTerritory === ' ') {
            return territories.map(lineItem => {

                if (lookups) {
                    territory = lookups.filter(x => x.code === ((lineItem.code) as any))

                    if (territory) {
                        return {
                            code: territory[0].code,
                            description: territory[0].description,
                            includeExclude: lineItem.includeExclude,
                            isDeleted: lineItem.isDeleted ? lineItem.isDeleted : false,
                            lastModifiedDate: lineItem.lastModifiedDate ? lineItem.lastModifiedDate : new Date(),
                            representationID: lineItem.representationID,
                            representationTerritoryID: lineItem.representationTerritoryID,
                            territoryID: territory[0].typeID,
                            tisnValidFrom: lineItem.tisnValidFrom
                        }
                    }

                }

            })
        }
    }

    public static mapIncludeTerritory(territories: ITerritories[]): string {

        if (territories) {
            return territories.filter(lineItem => lineItem.includeExclude == 'I').map(x => x.code).join(',');
        }
    }

    public static mapExcludeTerritory(territories: ITerritories[]): string {
        if (territories) {
            return territories.filter(lineItem => lineItem.includeExclude == 'E').map(x => x.code).join(',');
        }
    }

    public static mapIPRepresentationPools(includeAllPools: boolean, pools: IRepresentationPool[], usagePools?: any, includePool?: string, excludePool?: string, repID?: number): any {
        let pool;
        let includeTransformed = [];
        let excludeTransformed = [];
        let mergedArray;
        if (includePool || excludePool) {
            if (includePool && includePool.indexOf('Pools:') !== -1) {                                
                const start = includePool.indexOf('Pools:') + 'Pools:'.length;
                const end = includePool.indexOf(';Pool Categories:');                
                const includePools = includePool.slice(start, end === -1 ? undefined : end).trim().split(';');

                includeTransformed = includePools.map(value => ({
                    includeExclude: 'I',
                    value: value.toUpperCase()
                }))
                .filter(item => item.value !== 'ALL');                              
            }
            
                        
            if (excludePool && excludePool.indexOf('Pools:') !== -1) {
                let start = excludePool.indexOf('Pools:');
                let excludePools = [];
                if(start != -1){
                    start += 'Pools:'.length;
                    const end = excludePool.indexOf(';Pool Categories:');                
                    excludePools = excludePool.slice(start, end === -1 ? undefined : end).trim().split(';');
                }
                
                excludeTransformed = excludePools.map(value => ({
                    includeExclude: 'E',
                    value: value.toUpperCase()
                }));                               
            }
                        
            if (!includeAllPools && includePool && excludePool) {                
                mergedArray = includeTransformed.concat(excludeTransformed);
            }
            else if (includePool.length > 0 && excludePool.length === 0) {
                mergedArray = includeTransformed;
            }
            else if (excludePool.length > 0 && includePool.length === 0) {
                mergedArray = excludeTransformed;
            }
            else if (includeAllPools) {
                mergedArray = excludeTransformed;
            }
            let representationIDNo = (pools != undefined && pools.length != 0 ? pools[0].representationID : repID);
            let poolDetails

            if (!mergedArray?.length) {
                return null;
            }

            return mergedArray.map(lineItem => {
                if (pools && pools.length > 0) {
                    poolDetails = pools.filter(x => (x.code === lineItem.value && x.includeExclude === lineItem.includeExclude))
                }
                const isPoolsPresent = poolDetails && poolDetails.length;
                if (usagePools) {
                    pool = usagePools.filter(x => x.poolCode.toUpperCase() === lineItem.value.toUpperCase())
                    if (pool) {
                        return {
                            code: pool.length > 0 ? pool[0].poolCode : '',
                            description: pool.length > 0 ? pool[0].description : lineItem.value,
                            includeExclude: lineItem.includeExclude,
                            isDeleted: isPoolsPresent ? poolDetails[0].isDeleted : false,
                            lastModifiedDate: isPoolsPresent ? poolDetails[0].lastModifiedDate : new Date(),
                            representationID: isPoolsPresent ? poolDetails[0].representationID : representationIDNo,
                            representationPoolID: isPoolsPresent ? poolDetails[0].representationPoolID : 0,
                            poolID: pool.length > 0 ? pool[0].poolId : 0
                        }
                    }

                }

            })


        }
        else if (pools && includePool === ' ' && excludePool === ' ') {
            return pools.map(lineItem => {

                if (usagePools) {
                    pool = usagePools.filter(x => x.poolCode.toUpperCase() === lineItem.code.toUpperCase())

                    if (pool) {
                        return {
                            code: pool[0].code,
                            description: pool[0].description,
                            includeExclude: lineItem.includeExclude,
                            isDeleted: lineItem.isDeleted ? lineItem.isDeleted : false,
                            lastModifiedDate: lineItem.lastModifiedDate ? lineItem.lastModifiedDate : new Date(),
                            representationID: lineItem.representationID,
                            representationPoolID: lineItem.representationPoolID,
                            poolID: pool[0].typeID,
                        }
                    }
                }
            })
        }
    }

    public static mapIPRepresentationPoolCategories(pools: IRepresentationPoolCategory[], lookupValues?: any, includePoolCategory?: string, excludePoolCategory?: string, repID?: number): any {
        let poolCategory;
        let includeTransformed;
        let excludeTransformed;
        let mergedArray;
        if (includePoolCategory || excludePoolCategory) {
            if (includePoolCategory) {
                let includePools = includePoolCategory.split(';');
                includeTransformed = includePools.map(value => ({
                    includeExclude: 'I',
                    value: value.toUpperCase()
                }));
            }
                                    
            if (excludePoolCategory) {
                let excludePools = excludePoolCategory.split(';');
                excludeTransformed = excludePools.map(value => ({
                    includeExclude: 'E',
                    value: value.toUpperCase()
                }));
            }
                        
            if (includePoolCategory && excludePoolCategory) {
                mergedArray = includeTransformed.concat(excludeTransformed);
            }
            else if (includePoolCategory.length > 0 && excludePoolCategory.length === 0) {
                mergedArray = includeTransformed;
            }
            else if (excludePoolCategory.length > 0 && includePoolCategory.length === 0) {
                mergedArray = excludeTransformed;
            }
          
            let representationIDNo = (pools != undefined && pools.length != 0 ? pools[0].representationID : repID);
            let poolCategoryDetails

            if (!mergedArray) {
                return null;
            }

            return mergedArray.map(lineItem => {
                if (pools && pools.length > 0) {
                    poolCategoryDetails = pools.filter(x => (x.code === lineItem.value && x.includeExclude === lineItem.includeExclude))
                }
                const isPoolsPresent = poolCategoryDetails && poolCategoryDetails.length;
                if (lookupValues) {
                    poolCategory = lookupValues.PoolCategory.lookups.filter(x => x.code=== lineItem.value)
                    if (poolCategory) {
                        return {
                            code: poolCategory.length > 0 ? poolCategory[0].code : '',
                            description: poolCategory.length > 0 ? poolCategory[0].description : lineItem.value,
                            includeExclude: lineItem.includeExclude,
                            isDeleted: isPoolsPresent ? poolCategoryDetails[0].isDeleted : false,
                            lastModifiedDate: isPoolsPresent ? poolCategoryDetails[0].lastModifiedDate : new Date(),
                            representationID: isPoolsPresent ? poolCategoryDetails[0].representationID : representationIDNo,
                            representationPoolCategoryID: isPoolsPresent ? poolCategoryDetails[0].representationPoolCategoryID : 0,
                            poolCategoryID: poolCategory.length > 0 ? poolCategory[0].typeID : 0
                        }
                    }

                }

            })


        }
        else if (pools && includePoolCategory === ' ' && excludePoolCategory === ' ') {
            return pools.map(lineItem => {

                if (lookupValues) {
                    poolCategory = lookupValues.PoolCategory.lookups.filter(x => x.code.toUpperCase() === lineItem.code.toUpperCase())

                    if (poolCategory) {
                        return {
                            code: poolCategory[0].code,
                            description: poolCategory[0].description,
                            includeExclude: lineItem.includeExclude,
                            isDeleted: lineItem.isDeleted ? lineItem.isDeleted : false,
                            lastModifiedDate: lineItem.lastModifiedDate ? lineItem.lastModifiedDate : new Date(),
                            representationID: lineItem.representationID,
                            representationPoolCategoryID: lineItem.representationPoolCategoryID,
                            poolID: poolCategory[0].poolId,
                        }
                    }
                }
            })
        }
    }

    public static mapIncludePool(pools: IRepresentationPool[], poolCategories?: IRepresentationPoolCategory[], allPoolsIncluded?: boolean): string {

        const includedPools = (pools ?? [])
        .filter(lineItem => lineItem.includeExclude === 'I')
        .map(x => x.code);

        const includedPoolCategories = (poolCategories ?? [])
            .filter(lineItem => lineItem.includeExclude === 'I')
            .map(x => x.description);

        const segments: string[] = [];
        if (allPoolsIncluded) {
            segments.push(`Pools:ALL`);
        }
        else if (includedPools.length) {
            segments.push(`Pools:${includedPools.join(';')}`);
        }
        if (includedPoolCategories.length) {
            segments.push(`Pool Categories:${includedPoolCategories.join(';')}`);
        }

        return segments.join(';');
    }

    public static mapExcludePool(pools: IRepresentationPool[], poolCategories?: IRepresentationPoolCategory[]): string {
        
        const excludedPools = (pools ?? [])
        .filter(lineItem => lineItem.includeExclude === 'E')
        .map(x => x.code);

        const excludedPoolCategories = (poolCategories ?? [])
            .filter(lineItem => lineItem.includeExclude === 'E')
            .map(x => x.description);

        const segments: string[] = [];
        if (excludedPools.length) {
            segments.push(`Pools:${excludedPools.join(';')}`);
        }
        if (excludedPoolCategories.length) {
            segments.push(`Pool Categories:${excludedPoolCategories.join(';')}`);
        }

        return segments.join(';');               
    }

    public static mapIncludePoolCategories(poolCategories?: IRepresentationPoolCategory[]): string {
        
        const includedPoolCategories = (poolCategories ?? [])
            .filter(lineItem => lineItem.includeExclude === 'I')
            .map(x => x.code);

        return includedPoolCategories.join(';');
    }

     public static mapExcludePoolCategories(poolCategories?: IRepresentationPoolCategory[]): string {
        
        const excludedPoolCategories = (poolCategories ?? [])
            .filter(lineItem => lineItem.includeExclude === 'E')
            .map(x => x.code);

        return excludedPoolCategories.join(';');
    }

    public static mapSocIP(socIP: ISocIP, lookups: ILookupDictionary,usagePools?: IUsagePool[]): any {
        let societyLookUp;
        let territoriesLookup
        if(lookups){
             societyLookUp = getAgencyLookupValues(lookups, true);
             territoriesLookup = getLookupValues(TERRITORY_LOOKUP, lookups);
        }      
         
        let agency;
        if (socIP && socIP.ipRepresentations && socIP.ipRepresentations.length > 0) {
            return socIP.ipRepresentations.map(lineItem => {
                if (societyLookUp) {
                    if (lineItem.agencyID && Number(lineItem.societyName.value)) {
                        agency = societyLookUp.filter(x => x.code === (lineItem.societyName.value as any))

                    } else if (lineItem.agencyID) {
                        agency = societyLookUp.filter(x => x.code === (lineItem.agencyID as any))
                    } else {
                        agency = societyLookUp.filter(x => x.code === (lineItem.societyName.value as any))
                    }
                }

                if (lineItem.includePools && lineItem.includePools.value.includes("ALL")) {
                    lineItem.allPoolsIncluded = true;
                }

                const isAgency = agency && agency.length;
                return {
                    agencyID: isAgency && agency[0].code ? agency[0].code : lineItem.agencyID,
                    agencyName: isAgency && agency[0].description ? agency[0].description : lineItem.agencyName,
                    amendedDateTime: lineItem.amendedDateTime ? lineItem.amendedDateTime : (new Date()).toISOString().split('T')[0],
                    applicableTerritories: this.mapIPRepresentationTerritory(lineItem.applicableTerritories, territoriesLookup, lineItem['includeTerritories'].value, lineItem['excludeTerritories'].value, (lineItem.representationID ? lineItem.representationID : 0)),
                    economicRightDescription: lineItem.economicRightDescription ? lineItem.economicRightDescription : null,
                    creationClass: lineItem.creationClass.value,
                    economicRights: lineItem.economicRights.value,
                    externalReferenceID: null,
                    fromDate: (lineItem.fromDate.value) ? (new Date((lineItem.fromDate.value)).toISOString().split('T', 1)[0]) : (new Date().toISOString().split('T', 1)[0]),
                    toDate: lineItem.toDate.value,
                    isAgreementEnded: lineItem.isAgreementEnded ? lineItem.isAgreementEnded : false,
                    societyName: isAgency ? agency[0].description : '',
                    isDeleted: lineItem.isDeleted ? lineItem.isDeleted : false,
                    isWorld: lineItem.isWorld ? lineItem.isWorld : false,
                    lastModifiedDate: lineItem.lastModifiedDate ? lineItem.lastModifiedDate : (new Date()).toISOString().split('T')[0],
                    representationID: lineItem.representationID ? lineItem.representationID : 0,
                    role: lineItem.role.value,
                    sharePercentage: lineItem.sharePercentage ? lineItem.sharePercentage : "100.0",
                    shareSet: lineItem.shareSet.value?lineItem.shareSet.value:'',
                    signedDate: lineItem.signedDate ? lineItem.signedDate : (new Date()).toISOString().split('T')[0],
                    socIPID: isNullOrUndefined(socIP.socIPID) ? 0 : socIP.socIPID,
                    territories: lineItem.territories ? lineItem.territories : null,
                    applicablePools: this.mapIPRepresentationPools(lineItem.allPoolsIncluded,lineItem.applicablePools, usagePools, lineItem['includePools'].value, lineItem['excludePools'].value, (lineItem.representationID ? lineItem.representationID : 0)),
                    allPoolsIncluded: lineItem.allPoolsIncluded,
                    applicablePoolCategories: this.mapIPRepresentationPoolCategories(lineItem.applicablePoolCategories, lookups, lineItem['includePoolCategories'].value, lineItem['excludePoolCategories'].value, (lineItem.representationID ? lineItem.representationID : 0)),
                }

            })
        }
        else return []
    }

    public static mapInterestedPartStatetoState(socIP: ISocIP, lookups: ILookupDictionary): any {

        if (socIP && socIP.ipRepresentations && socIP.ipRepresentations.length > 0) {

            return socIP.ipRepresentations.map(lineItem => {
                let agency;
                if (lookups){
                    const societyLookUp = getAgencyLookupValues(lookups, true);
                    if (societyLookUp) {
                        if (lineItem.agencyID) {
                            agency = societyLookUp.find(x => x.code === (lineItem.agencyID ? lineItem.agencyID : lineItem.agencyID.value as any))
                        }
                        else {
                            agency = societyLookUp.find(x => x.code === lineItem.societyName.value)
                        }
                    }
                }
                
                return {
                    agencyID: lineItem.agencyID ? lineItem.agencyID : null,
                    agencyName: lineItem.agencyName ? lineItem.agencyName : null,
                    amendedDateTime: lineItem.amendedDateTime ? lineItem.amendedDateTime : null,
                    applicableTerritories: lineItem.applicableTerritories,
                    economicRightDescription: lineItem.economicRightDescription ? lineItem.economicRightDescription : null,
                    externalReferenceID: lineItem.externalReferenceID ? lineItem.externalReferenceID : null,
                    isAgreementEnded: lineItem.isAgreementEnded ? lineItem.isAgreementEnded : false,
                    isDeleted: lineItem.isDeleted ? lineItem.isDeleted : false,
                    isWorld: lineItem.isWorld ? lineItem.isWorld : false,
                    lastModifiedDate: lineItem.lastModifiedDate ? lineItem.lastModifiedDate : new Date(),
                    representationID: lineItem.representationID ? lineItem.representationID : 0,
                    sharePercentage: lineItem.sharePercentage ? lineItem.sharePercentage : "100.0",
                    signedDate: lineItem.signedDate ? lineItem.signedDate : new Date(),
                    socIPID: isNullOrUndefined(socIP.socIPID) ? 0 : socIP.socIPID,
                    territories: lineItem.territories ? lineItem.territories : null,
                    societyName: agency ? { value: agency.description, inputType: DROPDOWN_INPUT } : { value: '', inputType: DROPDOWN_INPUT },
                    fromDate: { value: lineItem.fromDate, inputType: DATE_INPUT },
                    toDate: { value: lineItem.toDate, inputType: DATE_INPUT },
                    economicRights: { value: lineItem.economicRights, inputType: DROPDOWN_INPUT },
                    shareSet: { value: lineItem.shareSet, inputType: READ_ONLY_INPUT },
                    role: { value: lineItem.role, inputType: DROPDOWN_INPUT },
                    includeTerritories: { value: this.mapIncludeTerritory(lineItem.applicableTerritories), inputType: TEXT_INPUT },
                    excludeTerritories: { value: this.mapExcludeTerritory(lineItem.applicableTerritories), inputType: TEXT_INPUT },
                    applicablePools: lineItem.applicablePools,
                    includePools:  { value: this.mapIncludePool(lineItem.applicablePools, lineItem.applicablePoolCategories, lineItem.allPoolsIncluded), inputType: TEXT_INPUT },
                    excludePools: lineItem.applicablePools ? { value: this.mapExcludePool(lineItem.applicablePools,lineItem.applicablePoolCategories), inputType: TEXT_INPUT } : { value: '', inputType: TEXT_INPUT },
                    creationClass: { value: lineItem.creationClass, inputType: DROPDOWN_INPUT },
                    allPoolsIncluded: lineItem.allPoolsIncluded,
                    applicablePoolCategories: lineItem.applicablePoolCategories,
                    includePoolCategories: { value: this.mapIncludePoolCategories(lineItem.applicablePoolCategories), inputType: TEXT_INPUT },
                    excludePoolCategories: lineItem.applicablePoolCategories ? { value: this.mapExcludePoolCategories(lineItem.applicablePoolCategories), inputType: TEXT_INPUT } : { value: '', inputType: TEXT_INPUT },

                }

            })
        }
        else return []
    }
}